import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  // Scroll to top on route change - със smooth анимация
  useEffect(() => {
    const scrollToTopSmooth = () => {
      // Ако има lenis инстанция, използваме нея със smooth
      if (window.lenis) {
        window.lenis.scrollTo(0, { 
          immediate: false,  // false за smooth анимация
          duration: 1.5,     // продължителност на анимацията в секунди
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) // easing функция
        });
      } else {
        // Иначе стандартно smooth скролване
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    };

    // Изчакваме малко за да се зареди новия контент
    const timeoutId = setTimeout(scrollToTopSmooth, 100);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  // Show/hide button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      // Вземаме текущата позиция от lenis или window
      const scrollY = window.lenis?.scroll || window.scrollY;
      if (scrollY > 400) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    if (window.lenis) {
      window.lenis.scrollTo(0, { 
        immediate: false,  // false за smooth анимация
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
      });
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <AnimatePresence>
      {showButton && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={scrollToTop}
          className="fixed bottom-24 right-6 z-50 w-12 h-12 bg-[#1a2332] text-white rounded-full shadow-lg hover:bg-[#2d3a4d] transition-all duration-300 flex items-center justify-center group"
          aria-label="Scroll to top"
          data-testid="scroll-to-top-button"
        >
          <ArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;